
import Vue from 'vue'
import { VIcon, VRating } from 'vuetify/lib'

export default Vue.extend({
  name: 'JcdcRatings',
  components: {
    VRating,
    VIcon,
  },
  props: {
    value: {
      type: Number,
      default: 0,
    },
    icon: {
      type: String,
      default: undefined,
      validator: (prop: string) =>
        ['star', 'circle', 'heart', 'number'].includes(prop),
    },
    length: {
      type: Number,
      default: 5,
    },
    size: {
      type: String,
      default: 'normal',
      validator: (prop: string) =>
        ['x-small', 'small', 'normal', 'large', 'x-large'].includes(prop),
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    halfIncrements: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      rating: this.value,
    }
  },
  computed: {
    fullIcon() {
      if (this.icon === 'circle') return '$ratingCircleFull'
      else if (this.icon === 'heart') return '$ratingHeartFull'
      return '$ratingFull'
    },
    emptyIcon() {
      if (this.icon === 'circle') return '$ratingCircleEmpty'
      else if (this.icon === 'heart') return '$ratingHeartEmpty'
      return '$ratingEmpty'
    },
    halfIcon() {
      if (this.icon === 'circle') return '$ratingCircleHalf'
      else if (this.icon === 'heart') return '$ratingHeartHalf'
      return '$ratingHalf'
    },
  },
})
